import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MultiQcUpdateDTO } from './multiplate-qc.dto';
import { Observable, timeout } from 'rxjs';
import { BBResponseContainer } from '../carrier/response-container';
import { environment } from '../../environments/environment';
import { SampleRedoDTO } from '../models/sampleRedoDTO';

@Injectable({
	providedIn: 'root'
})
export class MultiplateQcService {

	readonly SAMPLE_PROCESSING_API = environment.BB_SAMPLE_PROCESSING_API;
	readonly DELIVERY_PROCESSING_API = environment.BB_MA_DELIVERY_API;

	constructor(private readonly httpClient: HttpClient) { }

	genericMultiPlateUpdate(multiQcUpdateDTO: MultiQcUpdateDTO): Observable<BBResponseContainer> {
		const url = `${this.SAMPLE_PROCESSING_API}generic/plates/redo/multi`;
		return this.httpClient.put<BBResponseContainer>(url, multiQcUpdateDTO).pipe(timeout(environment.defaultTimeout));
	}

	updateRedoSample(labId: string,  sampleRedoDetails: SampleRedoDTO): Observable<BBResponseContainer>{
		const url = `${this.DELIVERY_PROCESSING_API}update/redoSample/${labId}`;
		return this.httpClient.put<BBResponseContainer>(url, sampleRedoDetails).pipe(timeout(environment.defaultTimeout));
	}

	getQCFailPlateDetailsForMultiUpdate(lab: string, plateID: string, stepName: string, plateType: string): Observable<BBResponseContainer> {
		const url = `${this.SAMPLE_PROCESSING_API}qcFailPlateProcessDetails/${lab}/${plateID}/${stepName}?platetype=${plateType}`;
		return this.httpClient.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
	}
}
